import React from 'react'
import { CloseIcon } from 'icons/CloseIcon'
import styled, { CSSProperties } from 'styled-components'
import { space, SpaceProps, system } from 'styled-system'

export interface IconProps extends SpaceProps {
  name: string
  color?: string
  size?: number
  transform?: string
}

const IconContainer = styled.div<{
  color: CSSProperties['color']
  size: number
}>(space, system({ transform: true }), ({ color, size }) => ({
  lineHeight: 0,
  svg: {
    width: size,
    height: size,
    stroke: color,

    '&:not([fill="none"])': {
      fill: color,
    },

    '*:not([data-no-fill="true"])': {
      stroke: color,
      fill: color,
    },

    'path[data-no-fill="true"]': {
      color,
    },
  },
}))

export const Icon: React.FC<IconProps> = ({ name, color, size = 18, ...props }) => {
  return (
    <IconContainer color={color} size={size} {...props}>
      <CloseIcon />
    </IconContainer>
  )
}
